import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { RewardComponentProps } from './types'
import { Grid, Text } from './styles'

export const RewardComponent: FunctionComponent<RewardComponentProps> = ({
  reward,
  stars,
}) => {
  const { t } = useTranslation()

  return (
    <Grid>
      <span>{t('influencer.reward')}:</span>
      <Text>
        &#36;{reward}&nbsp;(
        {t('influencer.rate')}&nbsp;{stars})
      </Text>
    </Grid>
  )
}
